// const webUrl = "http://school.yuwangyun.com:8065/";   
// const web = "http://school.yuwangyun.com:8065/";
const webUrl = "http://demo.yuwangyun.com/";    
const web = "http://demo.yuwangyun.com/";
const c_mobile = /^1[3|4|5|6|7|8][0-9]{9}$/;  //判断手机号码正则
export default {
	webUrl,
	web,
	c_mobile,
	getSortFun
}
function getSortFun(order, sortBy) {
	const ordAlpah = (order == 'asc') ? '>' : '<';
	const sortFun = new Function('a', 'b', 'return a.' + sortBy + ordAlpah + 'b.' + sortBy + '?1:-1');
	return sortFun;
}